import { TrackingProvider } from '@gjensidige/core-analytics';

// Export the local TrackingProvider so the correct CoreAnalytics version is used
export const BuildersComponentsTrackingProvider = TrackingProvider;
